import { Directive } from '@angular/core';

@Directive({
  selector: '[uniLabelTip]',
})
export class UniLabelTipDirective {}
